import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

Sentry.init({
  dsn,
  environment:
    import.meta.env.VITE_SENTRY_ENVIRONMENT ||
    import.meta.env.MODE ||
    "development",
  release: import.meta.env.VITE_RELEASE,
  tracesSampleRate: 0,
  enabled: Boolean(dsn),
});

export { Sentry };
